import { UserHttpClient } from '@autopass-web/mochi-web-api';

const http = new UserHttpClient({});

class Repository {
  fetchPromotions = async ({ distributor, parkinglotOnline }) => {
    const { error, data } = await http.fetchPromotions({
      distributor,
      transactionType: undefined,
      filter: 'not_end',
      parkinglotOnline,
    });
    let result = data.data.data.map((p) => {
      p.badageLabel = p.badageLabel || '麻吉專屬';
      p.distributor = p.distributor.uid;
      p.displayPromotionTypes = p.displayPromotionTypes.map((t) =>
        !t ? 'OnStreetParkingPromotion' : t,
      );
      return p;
    });
    return { error, data: result };
  };

  fetchPromotionCollections = async ({ distributor }) => {
    const { error, data } = await http.fetchPromotionCollections(distributor);
    return { error, data: data.data.data };
  };

  fetchPromotionUserUsageStatus = async (id) => {
    const { error, data } = await http.fetchPromotionUserUsageStatus(id);
    return { error, data: data.data.data };
  };
}

export default Repository;
